

import { usePrivateMutation as useMutation } from "@/lib/query/core/use-private-mutation";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";

type UpdateAdminProfilePasswordInput = {
  currentPassword: string;
  nextPassword: string;
};

export function useUpdateProfilePasswordMutation() {
  const mutation = useMutation({
    mutationFn: (input: UpdateAdminProfilePasswordInput) =>
      apiJsonClient<unknown>(endpoints.admin.profilePassword, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(input),
      }),
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
